export class MessageBoxViewRestrictionSm {
	textAreaWidth = '260px';
	btnWidth = '157px';
	fontSize = '22px';
	btnHeight = '50px';
}
